import type { TMessages } from '@/types/TMessages'

export const messages = {
  notice: 'Цена без НДС',
  leaveRequest: 'Откликнуться',
  validTo: 'Действует до {date}',
} satisfies TMessages
